<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA DE PERSONAS</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container table-adjustable mat-elevation-z1" tabindex="0">
            <div >
                <table
                    mat-table
                    [dataSource]="
                        (asyncOutsider | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let outsider">
                            <div class="action-buttons">
                                <a (click)="updateOutsider(outsider)" class="icon-button">
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>edit</mat-icon></span
                                    >
                                </a>
                                <a
                                    (click)="eliminate(outsider)"
                                    appOnlysuperuser="/outsider"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>delete</mat-icon></span
                                    >
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="identificationCode">
                        <th mat-header-cell *matHeaderCellDef>
                            Código de identificación
                        </th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider.identificationCode }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="identificationType">
                        <th mat-header-cell *matHeaderCellDef>
                            Tipo de identificación
                        </th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider.identificationType }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Nombres</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider.name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell *matHeaderCellDef>Apellidos</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider.lastName }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="civilianStatus">
                        <th mat-header-cell *matHeaderCellDef>EStado civil</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider.socioeconomicStatus?.civilianStatus }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="birthDate">
                        <th mat-header-cell *matHeaderCellDef>Fecha de nacimiento</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider?.birthDate }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Correo</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider?.email }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef>
                            Teléfono
                        </th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider?.phone }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sex">
                        <th mat-header-cell *matHeaderCellDef>Género</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider?.sex }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef>Lugar de residencia</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider?.location?.city }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="placeBirth">
                        <th mat-header-cell *matHeaderCellDef>Lugar de nacimiento</th>
                        <td mat-cell *matCellDef="let outsider">
                            {{ outsider?.placeBirth?.city }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
                </div>
        </section>
        <pagination-controls
            (pageChange)="fetchOutsider($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
